// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"52a769e0","454":"b11aca30","799":"ca4f2cbd"}[chunkId] + ".chunk.js";
};